<agpr-dialog-container
    [id]="'bulkActionConfirmationDialogComponent'"
    [heading]="dialogHeading"
    (close)="cancel()"
>
    <div class='agpr-bulkActionConfirmationDialogComponent-content'>
        <agpr-message
            id="bulkActionConfirmationDialogComponent.warningMessage"
            [severity]="messageSeverityEnum.warning"
        >
            {{ 'Common.bulkActionConfirmation.actionIsPermanent' | localize }}
            @if (showTimeWarning) {
                <br>
                {{ 'Common.bulkActionConfirmation.actionMayTakeSeveralMinutes' | localize }}
            }
        </agpr-message>
        <div
            class="agpr-bulkActionConfirmationDialogComponent-message"
        >
            {{ message | localize:messageParameters }}
        </div>
        <agpr-message
            id="bulkActionConfirmationDialogComponent.infoMessage"
            [severity]="messageSeverityEnum.info"
        >
            {{ itemCountLabel | localize : {
                count: itemCount
                }
            }}
        </agpr-message>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            (click)="cancel()"
            [label]="cancelLabel"
            [style]="buttonTypes.secondary"
            id="bulkActionConfirmationDialogComponent.cancelButton"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            (click)="ok()"
            [label]="okLabel"
            id="bulkActionConfirmationDialogComponent.okButton"
            [style]="showTimeWarning? buttonTypes.secondary : buttonTypes.primary"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
